import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { RaportyGodzinoweDaneResponse } from 'src/app/modele/administracja/raportyGodzinoweDane';
import { MojeRaportyGodzinoweFiltryModel } from 'src/app/modele/administracja/mojeRaportyGodzinoweFiltry';
import { RaportyGodzinoweFiltryModel } from 'src/app/modele/administracja/raportyGodzinoweFiltry';
import {
  DodajGodzinyPracyModel,
  DodajGodzinyPracyRezultat,
  EdytujDomyslnaLiczbeGodzinPracyModel,
  EdytujGodzinyPracyDniaModel,
  UsunGodzinyPracyDniaModel,
} from 'src/app/modele/administracja/raportyGodzinoweRequest';
import { PojedynczyElementResponse } from 'src/app/modele/wspolne/pojedynczyElement';
import { RejestrFiltrowanyRequest } from 'src/app/modele/wspolne/rejestrFiltrowanyRequest';
import { ResponseBazowy } from 'src/app/modele/wspolne/responseBazowy';
import { Zalacznik } from 'src/app/modele/wspolne/zalacznik';
import { SerwisBazowy } from '../bazowy.service';
import { AuthService } from '../ogolne/auth.service';
import { ErrorService } from '../ogolne/error.service';
import { LoadingService } from '../ogolne/loading.service';
import { PobierzProjektyFiltr } from 'src/app/modele/projekty/pobierzProjektyFiltr';
import { Projekt } from 'src/app/modele/projekty/projekt';
import { StronicowanaListaWynikowResponse } from 'src/app/modele/wspolne/stronicowanaListaWynikowResponse';
import { Uzytkownik } from 'src/app/modele/uzytkownik/uzytkownik';
import { ListaWynikowResponse } from 'src/app/modele/wspolne/listaWynikowResponse';

@Injectable({
  providedIn: 'root',
})
export class RaportyService extends SerwisBazowy {
  constructor(
    httpClient: HttpClient,
    authService: AuthService,
    errorService: ErrorService,
    loaderService: LoadingService,
    translate: TranslateService
  ) {
    super(httpClient, authService, errorService, loaderService, translate);
  }

  pobierzDaneDoEdycjiRaportowGodzinowych(
    model: RejestrFiltrowanyRequest<RaportyGodzinoweFiltryModel>
  ): Observable<PojedynczyElementResponse<RaportyGodzinoweDaneResponse>> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/PobierzDaneDoEdycjiRaportowGodzinowych',
      model
    );
  }

  dodajGodzinyPracy(
    model: DodajGodzinyPracyModel
  ): Observable<PojedynczyElementResponse<DodajGodzinyPracyRezultat>> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/DodajGodzinyPracy',
      model
    );
  }

  edytujDomyslnaLiczbeGodzinPracy(
    model: EdytujDomyslnaLiczbeGodzinPracyModel
  ): Observable<ResponseBazowy> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/EdytujDomyslnaLiczbeGodzinPracy',
      model
    );
  }

  usunGodzinyPracyDnia(
    model: UsunGodzinyPracyDniaModel
  ): Observable<ResponseBazowy> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/UsunGodzinyPracyDnia',
      model
    );
  }

  edytujGodzinyPracyDnia(
    model: EdytujGodzinyPracyDniaModel
  ): Observable<ResponseBazowy> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/EdytujGodzinyPracyDnia',
      model
    );
  }

  edytujGodzinyPracyDniaBatch(
    zmiany: EdytujGodzinyPracyDniaModel[]
  ): Observable<ResponseBazowy> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/EdytujGodzinyPracyDniaBatch',
      { zmiany }
    );
  }

  public PobierzProjekty(
    model: RejestrFiltrowanyRequest<PobierzProjektyFiltr>,
    zLadowaczem: boolean
  ) {
    if (zLadowaczem) {
      return this.wykonajAkcje<
        RejestrFiltrowanyRequest<PobierzProjektyFiltr>,
        StronicowanaListaWynikowResponse<Projekt>
      >(this.AdresApi + 'Raporty/PobierzProjekty', model);
    } else {
      return this.wykonajAkcjeBezLadowacza<
        RejestrFiltrowanyRequest<PobierzProjektyFiltr>,
        StronicowanaListaWynikowResponse<Projekt>
      >(this.AdresApi + 'Raporty/PobierzProjekty', model);
    }
  }

  pobierzUzytkownikow(zLadowaczem: boolean) {
    if (zLadowaczem) {
      return this.wykonajAkcjeBezModelu<ListaWynikowResponse<Uzytkownik>>(
        this.AdresApi + 'Raporty/PobierzUzytkownikow'
      );
    } else {
      return this.wykonajAkcjeBezModelu<ListaWynikowResponse<Uzytkownik>>(
        this.AdresApi + 'Raporty/PobierzUzytkownikow'
      );
    }
  }

  eksportujRaportyGodzinowe(
    model: RaportyGodzinoweFiltryModel
  ): Observable<PojedynczyElementResponse<Zalacznik>> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/EksportujRaportyGodzinowe',
      model
    );
  }

  pobierzMojeRaportyGodzinowe(
    model: RejestrFiltrowanyRequest<MojeRaportyGodzinoweFiltryModel>
  ): Observable<PojedynczyElementResponse<RaportyGodzinoweDaneResponse>> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/PobierzMojeRaportyGodzinowe',
      model
    );
  }

  eksportujMojeRaportyGodzinowe(
    model: MojeRaportyGodzinoweFiltryModel
  ): Observable<PojedynczyElementResponse<Zalacznik>> {
    return this.wykonajAkcje(
      this.AdresApi + 'Raporty/EksportujMojeRaportyGodzinowe',
      model
    );
  }
}
